import React, { useState } from 'react';
import Header from '../misc/Header';
import FilterPlan from './Filters/FilterPlan';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  colorAndFont: {
    color: theme.palette.brand.greenDark,
    fontWeight: 600,
  },
}));

export default function LineHeader({ filterPlan, setFilterPlan }) {
  const classes = useStyles();
  const [filterName, setFilterName] = useState('All Plans');

  return (
    <div className={classes.colorAndFont}>
      <Header header={` Lines in: ${filterName}`}>
        <FilterPlan
          filterPlan={filterPlan}
          setFilterPlan={setFilterPlan}
          setFilterName={setFilterName}
        />
      </Header>
    </div>
  );
}
